import React from 'react';
import PropTypes from 'prop-types';

class YearPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.toggle);
  }

  toggle = () => {
    const { expanded } = this.state;
    if (!expanded) {
      document.addEventListener('click', this.toggle);
      this.setState({ expanded: true });
    } else {
      document.removeEventListener('click', this.toggle);
      this.setState({ expanded: false });
    }
  };

  getYears = () => {
    const { year, endYear, withAllOption } = this.props;

    let i = 0;
    let yearsList = [];
    let startYear = endYear - 20;
    while (startYear + i !== endYear + 1) {
      yearsList.push(
        <div
          key={startYear + i}
          className={`year ${startYear + i === year ? 'active' : ''}`}
          onClick={this.handleYearChoose(startYear + i)}
        >
          {startYear + i}
        </div>
      );
      startYear < endYear + 1 ? i++ : i--;
    }

    if (withAllOption) {
      yearsList.push(
        <div key={'All'} className={`year ${year ? '' : 'active'}`} onClick={this.handleYearChoose('All')}>
          All
        </div>
      );
    }

    return yearsList.reverse();
  };

  handleYearChoose = year => () => {
    const { yearPickAction } = this.props;
    yearPickAction(year);
    this.toggle();
  };

  render() {
    const { width, height, year, label, disabled } = this.props;
    const { expanded } = this.state;

    return (
      <div className={`year-picker ${expanded ? 'expanded' : ''}`}>
        <label>{label}</label>
        <div
          className={`chosen-year-holder ${disabled ? 'chosen-year-holder_disabled' : ''}`}
          style={{ width: width, height: height }}
          onClick={() => {
            if (!disabled) this.toggle();
          }}
        >
          {year || 'All'}
          <div className='open-arrow' />
        </div>
        {expanded ? (
          <div className='drop-down' style={{ width: width }}>
            {this.getYears()}
          </div>
        ) : null}
      </div>
    );
  }
}

YearPicker.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  startYear: PropTypes.number,
  endYear: PropTypes.number,
  year: PropTypes.number,
  yearPickAction: PropTypes.func.isRequired,
  label: PropTypes.string,
  withAllOption: PropTypes.bool,
  disabled: PropTypes.bool,
};

YearPicker.defaultProps = {
  width: '100%',
  height: '100%',
  endYear: new Date().getFullYear() + 1,
  label: 'by Model Year',
  withAllOption: false,
  disabled: false,
};

export default YearPicker;



// WEBPACK FOOTER //
// ./src/app/Components/YearPicker.jsx